export const pt = {
	footer: {
		description:
			"Sistema de Validação de Selos, garantindo a conformidade e segurança de produtos em todo o Brasil.",
		resources: "Recursos",
		support: "Suporte",
		legal: "Legal",
		validation: "Validação de Selos",
		history: "Histórico de Consultas",
		reports: "Relatórios e Estatísticas",
		geolocation: "Geolocalização",
		complaint: "Denúncia de Irregularidades",
		helpCenter: "Central de Ajuda",
		tutorials: "Tutoriais",
		contact: "Contato",
		faq: "FAQ",
		reportProblem: "Reportar Problema",
		terms: "Termos de Uso",
		privacy: "Política de Privacidade",
		cookies: "Política de Cookies",
		licenses: "Licenças",
		portal: "Portal",
		copyright: "Todos os direitos reservados.",
		social: {
			facebook: "Facebook",
			twitter: "Twitter",
			instagram: "Instagram",
			youtube: "YouTube",
		},
	},

	nav: {
		queryHistory: "Histórico de Consultas",
		validateSeal: "Validar Selo",
		howItWorks: "Como Funciona",
		faq: "Dúvidas Frequentes",
		reportProblem: "Denunciar Problema",
		contact: "Contato",
		menu: "Menu",
		benefits: "Benefícios",
		resources: "Recursos",
	},
	querysFilter: {
		title: "Filtros",
		description: "Refine sua busca utilizando os filtros abaixo.",
		inputPlaceholder: "Busca por ID",
		dateFilter: {
			all: "Todas as datas",
			today: "Hoje",
			lastSevenDays: "Ultimos 7 dias",
			lastThirtyDays: "Ultimos 30 dias",
		},
	},
	common: {
		loadingConsultation: "Realizando consulta",
		cancel: "Cancelar",
		confirm: "Confirmar",
		back: "Voltar",
		retry: "Tentar novamente",
		loading: "Carregando...",
		error: "Erro",
		success: "Sucesso",
		yes: "Sim",
		no: "Não",
		close: "Fechar",
		save: "Salvar",
		delete: "Excluir",
		edit: "Editar",
		view: "Visualizar",
		send: "Enviar",
		next: "Próximo",
		previous: "Anterior",
		validations: "Validações",
		validating: "Validando...",
		photo: "Foto",
		qrCode: "QR Code",
		list: "Lista",
		map: "Mapa",
		seal: "Selo",
		code: "Código",
		loadImages: "Carregar imagem",
	},
	camera: {
		instructions: {
			title: "Prepare o selo",
			description:
				"Aponte a câmera para o selo e aguarde. O sistema reconhecerá o selo e tirará a foto automaticamente.",
			focusDesc: "Mantenha o celular firme enquanto o sistema tira a foto.",
			button: "Começar",
		},
		takePhoto: "Tirar foto",
		selectFile: "Selecionar imagem",
		retake: "Nova foto",
		switchCamera: "Trocar câmera",
		positionSealHere: "Alinhe o selo aqui",
		tapScreen: "Toque na tela para focar",
		tapToTakePhoto: "Toque na tela para tirar a foto",
		guidancePreparing: "Preparando a câmera...",
		guidanceFind: "Aponte a câmera para o selo.",
		guidanceCloser: "Aproxime o celular do selo.",
		guidanceFarther: "Afaste um pouco o celular.",
		guidanceCenter: "Centralize o selo na tela.",
		guidanceHold: "Perfeito. Mantenha o celular parado.",
		guidanceCapturing: "Capturando a foto...",
		guidanceDetected: "Mantenha o celular parado e aguarde.",
		waitingWhileCameraLoads: "Aguarde enquanto a câmera carrega...",
		error: "Erro na câmera",
		permissionDenied:
			"Permissão de câmera negada. Por favor, permita o acesso à câmera.",
		cameraNotFound:
			"Nenhuma câmera encontrada. Verifique se seu dispositivo tem uma câmera disponível.",
		accessError: "Erro ao acessar a câmera. Tente novamente.",
		loadingTimeout:
			"A câmera está demorando muito para carregar. Verifique suas permissões.",
		capturedPhoto: "Serial capturado",
		orientation: {
			portraitRecommended: "Modo retrato recomendado",
			landscapeRecommended: "Modo paisagem recomendado",
			rotateToPortrait:
				"Gire seu dispositivo para o modo retrato para uma melhor experiência de captura.",
			rotateToLandscape:
				"Gire seu dispositivo para o modo paisagem para uma melhor experiência de captura.",
			continueAnyway: "Continuar mesmo assim",
		},
		errorValidatingSeal: "Erro ao validar o selo",
		errorSendingPhoto: "Erro ao enviar a foto",
		errorValidatingSealDescription:
			"Ocorreu um erro ao validar o selo. Por favor, tente novamente.",
		errorProcessingImage:
			"Ocorreu um erro ao processar sua imagem. Por favor, tente novamente.",
		aiValidationTitle: "A IA está analisando seu selo",
		aiValidationDescription:
			"Estamos verificando a foto e os itens de segurança. O resultado aparecerá automaticamente.",
		aiValidationPhoto: "Foto capturada",
		aiValidationStatus: "Análise em andamento",
		aiValidationWait: "Isso pode levar alguns instantes.",
		qrCodeNotFound: "QR code não encontrado",
		qrCodeNotFoundWithEntry:
			"Não foi possível identificar o QR code do selo informado. Certifique-se de que o selo está visível, bem iluminado e centralizado na foto.",
		qrCodeNotFoundGeneric:
			"Não foi possível identificar um QR code válido na imagem. Certifique-se de que o QR code está visível, bem iluminado e centralizado na foto.",
	},
	tutorial: {
		qrTutorial: {
			title: "Verificação de Autenticidade do Selo",
			description:
				"Para continuar, fotografe o selo. A inteligência artificial validará os itens de segurança.",
			button: "Clique aqui para tirar a foto",
		},
		photoStep: {
			step1: "Use o mesmo selo do QR Code escaneado;",
			step2: "Fotografe apenas um selo;",
			step3: "Centralize o selo na tela;",
			step4: "Não mova o celular ao fotografar;",
			step5: "Aguarde enquanto a Inteligência Artificial realiza a validação;",
		},
		navigation: {
			previous: "Anterior",
			next: "Próximo",
			readQr: "Ler QR Code",
		},
		modal: {
			title: "Prepare sua câmera",
			description: "Agora você está pronto para escanear o QR Code do selo!",
			button: "Vamos escanear!",
			autoRedirect: "Redirecionando automaticamente em 5 segundos...",
		},
	},
	securityAlert: {
		title: "Alerta de Segurança",
		potentiallyFake: "Selo potencialmente falso!",
		description:
			"O código único não corresponde ao esperado, o que pode indicar uma falsificação do selo.",
		question: "Deseja continuar e registrar esta verificação como inválida?",
		confirmIrregularity: "Confirmar Irregularidade",
	},
	errorDisplay: {
		geolocationRequired: "Geolocalização Necessária",
		sealNotFound: "Selo não encontrado",
		verificationError: "Erro na verificação",
		geolocationInstructions: {
			title: "Como habilitar a geolocalização:",
			step1: "• Clique no ícone de localização na barra de endereços",
			step2: '• Selecione "Permitir" para este site',
			step3: "• Recarregue a página após permitir",
		},
		tryAgain: "Tentar novamente",
		backToHome: "Voltar ao início",
		noResults: "Nenhum resultado encontrado",
		noValidations: "Nenhuma validação encontrada",
	},
	addressInfo: {
		title: "Endereço",
		street: "Logradouro",
		number: "Número",
		neighborhood: "Bairro",
		city: "Cidade",
		state: "Estado",
		zipCode: "CEP",
	},
	clientInfo: {
		title: "Informações do cliente",
		cnpj: "CNPJ",
		name: "Nome",
		phone: "Telefone",
		email: "E-mail",
	},
	contactPage: {
		title: "Entre em Contato",
		subtitle: "Envie sua mensagem para nossa equipe",
		emailInputLabel: "E-mail",
		phoneInputLabel: "Telefone (opcional)",
		messageInputLabel: "Mensagem",
		messageInputPlaceholder: "Escreva sua mensagem aqui...",
		submitButtonText: "Enviar Mensagem",
		whatsAppButton: "Contato via WhatsApp",
	},
	faqPage: {
		title: "Perguntas Frequentes",
		subtitle: "Encontre respostas para as dúvidas mais comuns",
		items: [
			{
				question: "O que são os selos e como funcionam?",
				answer:
					"Os selos são etiquetas de autenticidade aplicadas em cada produto. Cada selo possui uma numeração única e sequencial (ex: 1, 2, 3... até 1000), permitindo o rastreamento individual de cada produto produzido. Isso garante autenticidade e controle total da produção.",
			},
			{
				question: "Os selos podem ser rastreados individualmente?",
				answer:
					"Sim! Cada selo possui um número único que permite o rastreamento individual. Você pode consultar o histórico de qualquer selo, verificando quando foi criado, quando foi utilizado e em qual produto foi aplicado.",
			},
		],
	},
	denouncePage: {
		title: "Denunciar Selo Falsificado",
		subtitle: "Ajude-nos a combater falsificações reportando selos suspeitos",
		imagesRequired: "Por favor, adicione ao menos uma imagem.",
		submittingText: "Enviando...",

		imagesSectionTitle: "Imagens",

		imagesUploadLabel: "Clique ou arraste as imagens aqui",
		imagesUploadHint: "PNG, JPG, WEBP até 10MB cada",

		reporterSectionTitle: "Dados do Denunciante",
		sealSectionTitle: "Informações do Selo",
		detailsSectionTitle: "Detalhes da Denúncia",

		nameLabel: "Nome completo",
		namePlaceholder: "Seu nome",

		emailLabel: "E-mail",
		emailPlaceholder: "seu@email.com",

		phoneLabel: "Telefone (opcional)",
		phonePlaceholder: "(00) 00000-0000",

		sealCodeLabel: "Código do Selo",
		sealCodePlaceholder: "Ex: SEAL-2024-XXXX",

		sealTypeLabel: "Tipo de Selo",
		sealTypePlaceholder: "Selecione o tipo",
		sealTypeOptions: {
			holographic: "Holográfico",
			other: "Outro",
		},

		brandLabel: "Marca/Fabricante do Produto",
		brandPlaceholder: "Nome da marca",

		productLabel: "Nome do Produto",
		productPlaceholder: "Nome do produto",

		locationLabel: "Local de Compra/Encontro",
		locationPlaceholder: "Loja, cidade ou link do site",

		reasonLabel: "Motivo da Denúncia",
		reasonPlaceholder: "Selecione o motivo",
		reasonOptions: {
			fakeSeal: "Selo visivelmente falso",
			invalidCode: "Código inválido na validação",
			duplicate: "Código duplicado/já utilizado",
			damaged: "Selo adulterado/danificado",
			suspicious: "Produto suspeito de falsificação",
			other: "Outro motivo",
		},

		descriptionLabel: "Descrição detalhada",
		descriptionPlaceholder:
			"Descreva com detalhes o que observou de irregular no selo ou produto...",

		submitButtonText: "Enviar Denúncia",
	},

	hashVerification: {
		title: "Verificação do Código Único",
		description:
			"Compare o código único abaixo com o que está impresso no selo",
		howToVerify:
			"Como verificar: Compare caractere por caractere o código acima com o código impresso no selo.",
		doesNotMatch: "Não Corresponde",
		matches: "Sim, Corresponde",
		processing: "Processando...",
		validating: "Validando...",
	},
	loading: {
		validatingSeal: "Validando o selo...",
	},
	errorBoundary: {
		title: "Ocorreu um erro inesperado",
		description: "Algo deu errado durante o carregamento desta página.",
		reload: "Recarregar página",
	},

	geoProtectRoute: {
		title: "Obtendo sua localização",
		description:
			"Precisamos da sua localização para verificar os selos. Isso pode levar alguns segundos.",
		loading: "Carregando localização...",
	},
	errorsDisplay: {
		geolocationRequired: "Geolocalização necessária",
		sealNotFound: "Selo não encontrado",
		verificationError: "Erro na verificação",
		howToEnableGeolocation: "Como habilitar a geolocalização:",
		step1: "Clique no ícone de localização na barra de endereços",
		step2: 'Selecione "Permitir" para este site',
		step3: "Recarregue a página após permitir",
		retry: "Tentar novamente",
		backHome: "Voltar ao início",
	},

	qrCodePage: {
		sealModal: {
			alignSeal: "Alinhe o selo dentro da área indicada",
			title: "Selo não identificado",
			lightingTitle: "Iluminação",
			lightingDesc: "Evite sombras e reflexos no selo.",
			framingTitle: "Enquadramento",
			framingDesc: "Centralize o selo na marcação.",
			focusTitle: "Foco",
			focusDesc: "Foque a câmera antes de clicar.",
			usedSealTitle: "Correspondência",
			usedSealDesc: "Use o mesmo selo do QR Code",
			button: "Tirar foto",
		},
		centerSealAlert: "Centralize o selo na área demarcada",
		hashDoesNotMatch:
			"O número do selo não corresponde à nossa base de dados. Verifique se você está utilizando o mesmo selo do QR Code escaneado.",
		seeAllSecurityItems: "Ver todos os itens de segurança",
		experienceAR: "Experimente a Realidade Aumentada",
		info: "O número identificado na foto corresponde ao registro da base.",
		clickSealToCheck: "Clique no selo para conferir os itens de segurança",
		uniqueCodeValidated: "Código único validado com sucesso",
		uniqueCodeDoesNotMatch: "Código único não corresponde",
		serial: "Serial:",
		capColor: "Cor da Tampa",
		hash: "Hash",
		product: "Produto",
		serialNotFound: "Serial não encontrado",
		importer: "Importadora:",
		batch: "Lote:",
		uniqueCode: "Código único:",
		productInfo: "Informações do Produto",
		validated: "✓ Validado",
		takePhoto: "Tirar uma foto com IA",
		securityItems: {
			config: {
				useArrows: "Use as setas ou arraste para navegar",
				goToItem: "Ir para o item",
				noSecurityItems: "Ainda não há item de segurança disponível.",
			},
		},
		verificationResult: "Resultado da Verificação",
		suspicious:
			"Verifique se há sinais visuais de violação ou inconsistência e, em seguida, entre em contato com o fornecedor ou fabricante responsável pelo produto adquirido.",
		qrCodeVerification: "Verificação de QR Code",
		validQrCodeDescription:
			"Este QR Code parece válido, porém, analise os itens de segurança com inteligência artificial para validar a veracidade do selo!",
		authenticityAnalysis: "Análise de autenticidade do selo INMETRO",
		imageAnalyzed: "Imagem Analisada",
		qrCodeValid: "QR Code Válido",
		elements: "elementos",
		detectedElements: "Elementos Detectados",
		securityItemsTitle: "Itens de Segurança",
		explanation: "Explicação",
		dataComparison: "Comparação de Dados",
		dbSerial: "Serial do Banco de Dados",
		photoSerial: "Serial da Foto",
		confidence: "Confiança",
		backButton: "Voltar",
	},
	reportModal: {
		title: "Denunciar Irregularidade",
		description:
			"Informe onde você encontrou este selo suspeito e anexe uma foto",
		locationLabel: "Local da Irregularidade",
		locationPlaceholder: "Ex: Farmácia ABC, Rua das Flores, 123",
		locationHint:
			"Seja específico: nome do estabelecimento, endereço ou ponto de referência",
		photoLabel: "Foto do Selo Irregular",
		photoHint:
			"A foto ajudará nossa equipe a identificar melhor a irregularidade",
		takePhoto: "Tirar Foto",
		gallery: "Galeria",
		newPhoto: "Nova",
		positionSealHere: "Posicione o selo aqui",
		ensureReadable: "Certifique-se que está legível",
		sealReportedAsFake: "Selo reportado como FALSO:",
		sealIdentifiedAsFake:
			"Este selo foi identificado como potencialmente falso devido à não correspondência do código único.",
		reportSent: "Denúncia Enviada!",
		investigationMessage: "Nossa equipe irá investigar a irregularidade.",
		protocol: "Protocolo:",
		errorSending: "Erro ao Enviar Denúncia",
		tipsForBetterPhoto: "Dicas para uma foto melhor:",
		tips: {
			lighting: "• Certifique-se que o selo está bem iluminado",
			reflections: "• Evite reflexos e sombras",
			stability: "• Mantenha a câmera estável",
			sealSize: "• O selo deve ocupar boa parte da foto",
			readability: "• Verifique se todos os códigos estão legíveis",
		},
		sending: "Enviando...",
		report: "Denunciar",
	},
	additionalInfo: {
		title: "Informações Adicionais",
		description:
			"Para mais detalhes sobre a validação ou para reportar problemas, entre em contato com o suporte técnico através do site do Mistral.",
	},
	validations: {
		title: "Mapa de Validações",
		subtitle: "Visualize todas as validações de selos realizadas no sistema.",
		filters: {
			title: "Filtros",
			description: "Busque por endereço, número de série ou registro",
			placeholder: "Buscar validações...",
			status: {
				valid: "Validados",
				invalid: "Rejeitados",
				pending: "Em análise",
			},
			type: {
				title: "Tipo de validação",
				qrcode: "QR Code",
				photo: "Foto",
			},
		},
		list: {
			title: "Validações",
			loading: "Carregando validações...",
			empty: "Nenhuma validação encontrada",
			found: "validações encontradas",
			view: {
				list: "Lista",
				map: "Mapa",
			},
		},
		details: {
			title: "Detalhes",
			date: "Data",
			time: "Hora",
			serialNumber: "Número de série",
			registerNumber: "Número de registro",
			address: "Endereço completo",
			addressUnavailable: "Endereço não disponível",
			photo: {
				title: "Foto do selo",
				none: "Nenhuma foto disponível",
				capturedAt: "Capturado em: {{date}} às {{time}}",
			},
			viewDetails: "Ver detalhes",
			close: "Fechar detalhes",
		},
		map: {
			error: {
				title: "Erro ao carregar o mapa",
				description:
					"Verifique sua conexão com a internet ou tente novamente mais tarde.",
			},
			loadingMore: "Carregando mais validações...",
		},
	},
	internalDashboard: {
		header: {
			title: "Painel Administrativo",
			subtitle: "Sistema Interno Inmetro",
			systemOnline: "Sistema Online",
			signOut: "Sair",
		},
		welcome: {
			title: "Bem-vindo ao Sistema Interno",
			subtitle: "Escolha uma das opções abaixo para continuar",
		},
		cards: {
			mapAndQueries: {
				title: "Mapa e Consultas",
				description:
					"Acesse o mapa interativo e realize consultas de validação de selos",
				button: "Acessar Mapa",
			},
			history: {
				title: "Histórico",
				description:
					"Visualize o histórico completo de consultas e validações realizadas",
				button: "Ver Histórico",
			},
			userManagement: {
				title: "Usuários Internos",
				description:
					"Gerencie usuários internos do sistema - criar, editar e remover acessos",
				button: "Gerenciar Usuários",
			},
		},
	},
	loginPage: {
		title: "Entrar na sua conta",
		fields: {
			email: {
				label: "Email",
				placeholder: "Digite seu email",
			},
			password: {
				label: "Senha",
				placeholder: "Digite sua senha",
			},
		},
		links: {
			forgotPassword: "Esqueci minha senha",
		},
		rememberMe: "Lembrar meus dados",
		buttons: {
			signIn: "Entrar",
			signingIn: "Entrando...",
		},
		screenReader: {
			hidePassword: "Ocultar senha",
			showPassword: "Mostrar senha",
		},
		errors: {
			emailRequired: "Email é obrigatório",
			emailInvalid: "Email inválido",
			cpfInvalid: "CPF deve conter 11 dígitos",
			passwordRequired: "Senha é obrigatória",
			passwordMinLength: "Senha deve ter pelo menos 6 caracteres",
			invalidCredentials: "Email ou senha incorretos",
			serverError: "Erro interno do servidor",
		},
		toasts: {
			loginError: "Erro ao fazer login. Verifique suas credenciais.",
			loginSuccess: "Login realizado com sucesso!",
			serverError: "Erro interno do servidor. Tente novamente.",
		},
	},
	queryPage: {
		title: "Comparação de Entradas",
		sections: {
			imageComparison: "Comparação de Imagens",
			comparisonSummary: "Resumo da Comparação",
			detailedAnalysis: "Análise Detalhada",
		},
		sealOwner: {
			title: "Dados da empresa",
			description: "Informações da empresa responsável pelo selo.",
			cnpj: "CNPJ",
			companyName: "Nome da empresa",
			productName: "Nome do produto",
			notProvided: "Não informado",
		},
		sources: {
			database: "Serial Esperado",
			photo: "Foto",
		},
		fields: {
			serialNumber: "Número de série",
			publicHash: "Hash Pública",
		},
		status: {
			match: "Compatível",
			mismatch: "Divergente",
			partial: "Parcial",
			missing: "Não detectado",
			discrepancyDetected: "Divergência detectada",
			detected: "Detectado",
		},
		messages: {
			noImage: "Sem imagem",
			notFound: "Não encontrado",
			valueDiffers: "Este valor difere do registrado na base de dados.",
		},
		buttons: {
			back: "Voltar",
			validateAnother: "Validar outro selo",
		},
		emptyState: {
			title: "Nenhum registro encontrado",
			description: "Não há entradas disponíveis para esta consulta.",
			button: "Voltar",
		},
		notFound: {
			title: "Consulta não encontrada",
			description: "Não foi possível encontrar os dados para esta consulta.",
			button: "Voltar",
		},
		aiAnalysis: {
			title: "Análise Inteligente",
			badge: "Resposta gerada por IA",
			noAnalysis: "Não foi possível gerar uma análise para estas entradas.",
			loading: {
				title: "Analisando entradas...",
				description:
					"Nossa IA está comparando os dados e gerando insights sobre as entradas",
			},
			error: {
				title: "Erro na análise",
				description:
					"Não foi possível gerar a análise. Tente novamente mais tarde.",
				button: "Tentar novamente",
			},
			disclaimer:
				"Esta análise é gerada automaticamente e pode não refletir todas as nuances dos dados.",
		},
		dataComparisonCard: {
			title: "Verificação de Número de Série",
			database: "Base de Dados",
			found: "Encontrado",
			photo: "Foto (OCR)",
			detected: "Detectado",
			notDetected: "Não detectado",
			notFound: "Não encontrado",
			mismatchTitle: "Numeração Divergente",
			highConfidenceMessage:
				"A análise indica alta confiança de que o selo é autêntico (confiança: {confidence}%), porém a numeração detectada na foto não corresponde ao número registrado na base de dados. Isso pode indicar um selo legítimo aplicado incorretamente, uma possível adulteração ou uma foto tirada de outro selo.",
			lowConfidenceMessage:
				"A numeração detectada na foto não corresponde ao número registrado na base de dados. Além disso, a confiança da detecção é baixa ({confidence}%), o que pode indicar dificuldade na leitura ou problemas com o selo.",
			partialMessage:
				"O número de série da base de dados foi encontrado, mas não foi possível ler o número da foto. Isso pode acontecer se a imagem estiver com baixa qualidade ou o selo estiver danificado.",
		},
		explanationSection: {
			title: "Como interpretar os resultados?",
			levels: {
				high: {
					range: "80% - 100%",
					trust: "Alta confiança",
					description: "O elemento foi identificado com segurança.",
				},
				medium: {
					range: "60% - 79%",
					trust: "Confiança média",
					description:
						"Há indícios do elemento, mas recomendamos verificação adicional.",
				},
				low: {
					range: "0% - 59%",
					trust: "Baixa confiança",
					description: "O elemento não foi confirmado nesta captura.",
				},
			},
			footer:
				"Nossa inteligência artificial analisa a imagem em busca de elementos de segurança do selo INMETRO. A porcentagem indica o nível de certeza de que cada elemento foi identificado corretamente.",
		},
		verdictCard: {
			authentic: {
				title: "Selo Autêntico",
				subtitle:
					"Os itens de segurança do selo foram autenticados com sucesso!",
			},
			warning: {
				title: "Verificação Inconclusiva",
				subtitle: "Alguns elementos precisam de atenção",
			},
			suspicious: {
				title: "Selo Suspeito",
				subtitle: "Não foi possível confirmar a autenticidade",
			},
			aiBadge: "Análise por IA",
			overallConfidence: "Confiança Geral",
		},
	},
	notFoundPage: {
		title: "404",
		message: "Ops! A página que você está procurando não existe.",
		backText: "Você pode voltar para a",
		homeLink: "página inicial",
	},
	reportPage: {
		header: {
			badge: "Sistema de Validação de Selos",
			title: "Denúncia de Irregularidades",
			subtitle:
				"Reporte selos falsificados ou irregulares para contribuir com a segurança e conformidade.",
			anonymousTitle: "Denúncias anônimas",
			anonymousSubtitle: "Sua identidade será protegida",
			backButton: "Voltar para a página inicial",
		},
		howToReport: {
			title: "Como Denunciar",
			subtitle: "Siga estas etapas para fazer sua denúncia",
			steps: {
				step1: {
					title: "Preencha o formulário",
					description:
						"Forneça todos os detalhes possíveis sobre a irregularidade encontrada",
				},
				step2: {
					title: "Anexe evidências",
					description: "Envie fotos claras do selo suspeito para análise",
				},
				step3: {
					title: "Informe seus dados",
					description:
						"Seus dados são opcionais, mas ajudam no processo de investigação",
				},
				step4: {
					title: "Acompanhe o processo",
					description: "Receba atualizações sobre o andamento da sua denúncia",
				},
			},
		},
		identifyingFakes: {
			title: "Identificando Selos Falsos",
			subtitle: "Características para verificar",
			characteristics: {
				holographic: {
					title: "Elementos holográficos",
					description:
						"Verifique se o selo possui marca d'água e elementos holográficos que mudam conforme o ângulo",
				},
				qrCode: {
					title: "QR Code funcional",
					description:
						"Confira se o QR code é funcional e direciona para o site oficial do {{productName}}",
				},
				printQuality: {
					title: "Qualidade de impressão",
					description:
						"Observe se há erros de impressão, baixa qualidade gráfica ou cores incorretas",
				},
				serialNumber: {
					title: "Número de série válido",
					description:
						"Verifique se o número de série é válido no sistema oficial de consulta",
				},
			},
			guideLink: "Ver guia completo de identificação",
		},
		form: {
			title: "Formulário de Denúncia",
			subtitle:
				"Preencha os campos abaixo com informações sobre a irregularidade encontrada.",
			steps: {
				information: "Informações",
				contact: "Contato",
				confirmation: "Confirmação",
				stepLabel: "Etapa {{current}} de {{total}}",
			},
			fields: {
				irregularityType: {
					label: "Tipo de Irregularidade",
					placeholder: "Selecione o tipo de irregularidade",
					options: {
						fake: "Selo Falsificado",
						tampered: "Selo Adulterado",
						reused: "Selo Reutilizado",
						noSeal: "Produto sem Selo",
						other: "Outro",
					},
				},
				description: {
					label: "Descrição da Irregularidade",
					placeholder: "Descreva detalhadamente a irregularidade encontrada",
					hint: "Inclua detalhes como características do selo, problemas identificados e outras informações relevantes.",
				},
				location: {
					label: "Local",
					placeholder: "Onde o selo foi encontrado",
				},
				date: {
					label: "Data da Ocorrência",
				},
				image: {
					label: "Imagem do Selo",
					uploadText: "Clique para enviar",
					tips: {
						title: "Dicas para uma boa foto:",
						lighting: "Boa iluminação, sem reflexos",
						centered: "Selo completo e centralizado",
						sharp: "Imagem nítida e sem desfoque",
						format: "Formatos: JPG, PNG (máx. 5MB)",
					},
				},
				company: {
					label: "Empresa/Estabelecimento (opcional)",
					placeholder: "Nome da empresa ou estabelecimento",
					hint: "Informe o nome do estabelecimento onde o selo foi encontrado.",
				},
				contact: {
					label: "Email para Contato",
					placeholder: "seu@email.com",
					hint: "Seu email será usado apenas para atualizações sobre esta denúncia e não será compartilhado.",
				},
				terms: {
					label:
						"Declaro que as informações fornecidas são verdadeiras e estou ciente das consequências legais de uma denúncia falsa.",
				},
			},
			alerts: {
				optionalData:
					"Seus dados de contato são opcionais, mas ajudam no processo de investigação.",
				dataProtection: {
					title: "Proteção de Dados",
					description:
						"Seus dados pessoais são protegidos de acordo com a LGPD e utilizados apenas para o processo de investigação.",
				},
				falseReport: {
					title: "Atenção",
					description:
						"Denúncias falsas podem resultar em responsabilização legal. Certifique-se de fornecer informações precisas.",
				},
			},
			summary: {
				title: "Resumo da Denúncia",
				type: "Tipo:",
				location: "Local:",
				date: "Data:",
				contact: "Contato:",
				description: "Descrição:",
				attachedImage: "Imagem Anexada:",
			},
			buttons: {
				back: "Voltar",
				continue: "Continuar",
				submit: "Enviar Denúncia",
				submitting: "Enviando... {{progress}}%",
			},
		},
		success: {
			title: "Denúncia Enviada com Sucesso",
			subtitle:
				"Sua denúncia foi registrada e será analisada pela nossa equipe.",
			protocol: "Protocolo: #DEN-{{number}}",
			message:
				"Você receberá um email de confirmação com os detalhes da sua denúncia e poderá acompanhar o status através do seu painel.",
			buttons: {
				dashboard: "Acessar Painel",
				home: "Voltar para a Página Inicial",
			},
			help: {
				text: "Precisa de ajuda?",
				link: "Entre em contato com o suporte",
			},
		},
	},
	tutorialPage: {
		header: {
			skipTutorial: "Pular Tutorial",
			startCapture: "Começar a Captura",
			skipToCamera: "Pular para Câmera",
		},
		steps: {
			step1: {
				title: "Posicionamento Correto",
				subtitle:
					"Posicione o selo dentro da área demarcada na tela da câmera.",
				tips: {
					title: "Dicas:",
					center: "Centralize o selo na área demarcada",
					parallel: "Mantenha o dispositivo paralelo ao selo",
					avoid: "Evite ângulos inclinados que distorcem a imagem",
				},
			},
			step2: {
				title: "Iluminação Adequada",
				subtitle:
					"Certifique-se de que há boa iluminação para capturar todos os detalhes do selo.",
				examples: {
					good: "Exemplo Bom",
					bad: "Exemplo Ruim",
					goodLabel: "Boa iluminação",
					badLabel: "Iluminação insuficiente",
					correct: "Correto",
					incorrect: "Incorreto",
				},
				tips: {
					title: "Dicas:",
					naturalLight:
						"Utilize ambientes bem iluminados, preferencialmente com luz natural",
					avoidShadows: "Evite sombras sobre o selo",
					avoidReflections:
						"Evite reflexos diretos que podem ofuscar detalhes importantes",
				},
			},
			step3: {
				title: "Nitidez e Estabilidade",
				subtitle:
					"Mantenha o dispositivo estável e certifique-se de que a imagem está nítida antes de capturar.",
				examples: {
					good: "Exemplo Bom",
					bad: "Exemplo Ruim",
					sharp: "Nítido",
					blurry: "Desfocado",
				},
				tips: {
					title: "Dicas:",
					steadyHands: "Mantenha as mãos firmes ao tirar a foto",
					waitFocus: "Aguarde o foco automático antes de capturar a imagem",
					fullSeal:
						"Procure tirar uma foto com a imagem inteira do selo com todos detalhes",
					avoidMovement: "Evite movimentos bruscos durante a captura",
				},
			},
		},
		navigation: {
			previous: "Anterior",
			next: "Próximo",
		},
		rotationModal: {
			title: "Gire seu celular",
			description:
				"Para uma melhor experiência de captura, recomendamos usar a câmera na orientação horizontal.",
			button: "Entendi, vamos lá!",
			autoRedirect: "Redirecionando automaticamente em 5 segundos...",
		},
		welcomeModal: {
			title: "Tutorial de validação",
			subtitle: "Aprenda a tirar fotos perfeitas para validação de selos",
			available: {
				title: "Tutorial Disponível",
				description:
					"Deseja ver um breve tutorial sobre como tirar a melhor foto do selo?",
			},
			bestResults: {
				title: "Melhores Resultados",
				description:
					"O tutorial ajuda a garantir fotos nítidas e validações precisas",
			},
			buttons: {
				skip: "Pular Tutorial",
				start: "Ver Tutorial",
			},
		},
	},
	privacyPolicyPage: {
		title: "Política de Privacidade",
		company: "PRIMI TECNOLOGIA LTDA",
		introP1:
			"A PRIMI TECNOLOGIA LTDA (PRIMI), com sede à Estrada Rosa Scarpa, nº 65, Votuparim, Santana de Parnaíba, São Paulo – SP, CEP nº 06513-010, em cumprimento aos requisitos legais e pelo compromisso ao bom atendimento a seus prospects, visitantes, clientes, ex-clientes, fornecedores, prestadores de serviço, ex-fornecedores, ex-prestadores de serviço, usuários, candidatos à vaga, colaboradores e ex-colaboradores TITULARES, delimita a sua Política de Privacidade.",
		introP2:
			"Por meio desta Política a PRIMI visa o cumprimento dos requisitos legais da Lei Federal nº 13.709/2018 (Lei Geral de Proteção de Dados - LGPD), Código de Proteção e Defesa do Consumidor (Lei Federal nº 8.078 de 1990) e do Marco Civil da Internet (Lei Federal nº 12.965 de 2014), bem como suas atualizações e normas complementares, garantindo que em toda interação e tratamento dos dados dos TITULARES há processos sólidos e técnicos que consolidam a Segurança dos Dados e da Informação.",
		introP3:
			"Não apenas por suas certificações de segurança, a PRIMI conta com uma equipe dedicada e treinada para proteger todos os dados coletados e atua com a transparência desta política para assegurar aos TITULARES que seus dados estão protegidos contra vazamentos e violações, bem como utilizá-los estritamente às finalidades consentidas.",
		introP4:
			"Nós coletamos e utilizamos alguns dos dados pessoais de nossos usuários, como controladores e operadores desses dados pessoais, estando sujeitos a todo texto normativo associado.",
		introP5:
			"A PRIMI é a responsável pelo Tratamento dos Dados Pessoais dos TITULARES e determina as finalidades e meios de tratamento através desta política disponível em nosso website, canais e plataformas.",
		introP6:
			"Assim, por esses termos os TITULARES dão total consentimento ao Tratamento desses dados Pessoais.",
		section1: {
			title: "I. DOS DADOS COLETADOS E DA FORMA DE COLETA",
			p1: "Os dados coletados pela PRIMI, com o aceite dos TITULARES, são os Dados Cadastrais (Nome, CPF, telefone, entre outros); Dados de Acesso (senhas, dentre outros); Informações Digitais e Navegação (Cookies, entre outros); Dados Financeiros (dados de pagamento, outras informações).",
			p2: "A forma de coleta desses dados é diretamente com os TITULARES por meio das próprias plataformas ou por meio de terceiros de forma indireta.",
			p3: "Nas informações e nos dados fornecidos pelos TITULARES, a coleta direta se dá por meio das plataformas digitais da PRIMI (Site, Plataforma Primi, Selo Inteligente, centrais de atendimento, formulários, chatbots, entre outros).",
			p4: "Nas informações e nos dados obtidos por meio de terceiros, a PRIMI recebe dados e informações por meio de terceiros intermediários, por exemplo, em plataformas de contratação, órgãos públicos, inclusive Sistemas de Informação de crédito, entre outras.",
			p5: "Também, podem ser obtidas informações e dados de maneira automática por meio dos dispositivos que os TITULARES utilizam. Essas informações são utilizadas no intuito de aperfeiçoar a experiência dos TITULARES em nossas plataformas e utilitários, como cookies, tags, beacons para controle de identidade e sessão, por exemplo.",
			p6: "Inclusive, é possível que haja coleta de dados em mídias sociais (LinkedIn, Instagram, Facebook) e em órgãos públicos (Inmetro, Portal da Transparência, entre outros).",
		},
		section2: {
			title: "II. DO TRATAMENTO - ARMAZENAMENTO E PROTEÇÃO DOS DADOS",
			p1: "Os dados dos TITULARES são protegidos e assegurados pelas melhores tecnologias, técnicas e processos internos para prevenir vazamentos e violações.",
			p2: "A PRIMI conta com certificações de Segurança como ISO 27001 – Segurança da Informação e NBR 15540 – Segurança Gráfica, e adota processos físicos e digitais para a proteção dos seus dados, bem como as melhores e mais modernas práticas de segurança na Tecnologia da Informação.",
			p3: "A PRIMI protege seus dados por meio do acesso restrito aos Dados Pessoais, incluindo acesso eletrônico e físico com proteção por senha, mascaramento de dados, anonimização, dentre outras técnicas de proteção de dados.",
			p4: "Além disso, a PRIMI adota uma rígida Política de Segurança da Informação, que constantemente tem processos auditados interna e externamente; e, esses processos resguardam a integridade e sigilo dos dados tratados, especialmente pelo fato desses processos guiarem e orientarem as ações das pessoas internas e eventuais terceiros responsáveis pelo tratamento desses dados.",
			p5: "O prazo de armazenamento dos dados pessoais é pelo tempo em que for necessária sua utilização, a depender da obrigação legal respectiva do armazenamento, das necessidades e interesse legítimo da PRIMI.",
		},
		section3: {
			title: "III. DA FINALIDADE DA COLETA DE DADOS",
			p1: "Todos os dados coletados pela PRIMI têm diversas finalidades, dentre elas, mas não se limitando:",
			list: [
				{
					label: "Para a elaboração de nossos produtos:",
					text: "na confecção de materiais, a PRIMI pode utilizar os dados recebidos pelos clientes e pelos órgãos públicos, sendo requisitos necessários aos impressos de segurança;",
				},
				{
					label:
						"Para o cumprimento de atividades de nossas obrigações legais e exercício regular de direitos:",
					text: "os dados dos TITULARES são utilizados para cumprimento das obrigações legais com os órgãos públicos e entidades regulatórias (ANPD, INMETRO, entre outras). Inclusive, mesmo que haja o término da sua relação com a PRIMI, seus dados permanecerão sob domínio, considerando que alguns dados pessoais podem ser necessários para que a PRIMI exerça seus direitos garantidos em lei, inclusive como prova em processos judiciais, administrativos ou arbitrais;",
				},
				{
					label:
						"Para a utilização das nossas plataformas digitais e serviços do nosso atendimento ao cliente:",
					text: "a PRIMI pode utilizar os dados dos TITULARES para melhorar e personalizar as nossas plataformas ao seu perfil de usuário por meio de técnicas específicas;",
				},
				{
					label:
						"Para a realização de ações de Marketing e Comunicações com os TITULARES:",
					text: "a PRIMI pode utilizar os dados dos TITULARES para preparar comunicações e ações de marketing específicas. Para a interação com nossos serviços também é necessário o tratamento de dados;",
				},
				{
					label: "Para a prevenção de fraudes e análise de crédito:",
					text: "a PRIMI pode utilizar os dados dos TITULARES para análise de perfil no âmbito de nossas atividades;",
				},
				{
					label: "Para o atendimento do legítimo interesse da PRIMI:",
					text: "a PRIMI pode utilizar os dados dos TITULARES para a realização de estudos estatísticos, criação de métricas, indicadores, para processo seletivo, para contratação de fornecedores e prestadores de serviço, campanhas de produtos e/ou ofertas.",
				},
			],
		},
		section4: {
			title: "IV. DO COMPARTILHAMENTO DE DADOS PESSOAIS",
			p1: "A PRIMI somente compartilha dados pessoais com terceiros em legítimo interesse e com autoridades públicas para cumprimento de obrigações legais e sob determinação legal e judicial.",
			p2: "Nesse compartilhamento de dados pessoais, a PRIMI possui processos para assegurar que a parte receptora desses dados os receba de maneira adequada, garantindo o sigilo da transferência dos dados. A PRIMI realiza transferência de dados podendo ser internacional, por meio de processos seguros com fornecedores confiáveis.",
		},
		section5: {
			title: "V. DOS DIREITOS E DEVERES DOS TITULARES",
			p1: "A qualquer tempo os TITULARES têm o direito de saber sobre o tratamento dos seus dados pessoais; de quais dados pessoais são tratados; para qual finalidade são tratados; de solicitar e corrigir dados incompletos, inexatos ou desatualizados; de solicitar anonimização, bloqueio, ou eliminação dados que entender excessivos; de pedir a revisão de dados que lhe são de seu interesse; de solicitar a eliminação de dados tratados consentidamente, salvo se para cumprimento de obrigação legal ou outro interesse legítimo da PRIMI; de se negar a consentir os termos - neste caso, a PRIMI informará sobre as consequências do não-consentimento.",
			p2: "Os TITULARES têm direito de saber como a PRIMI trata seus dados, com resposta obrigatória em até 15 dias em formato completo ou imediatamente com resposta simplificada.",
			p3: "Os dados tratados dos TITULARES podem incluir informações sobre a finalidade do tratamento, categorias de dados, prazos de armazenamento, e, entidades com quem os dados foram compartilhados. Também, os TITULARES podem solicitar a portabilidade de dados - exceto os já anonimizados.",
			p4: "A PRIMI recomenda para que os TITULARES sempre mantenham a confidencialidade de seu login e senha, e de jamais compartilhar seus dados e informações pessoais com terceiros. A PRIMI não pode se responsabilizar pelo compartilhamento indevido desses dados pelos próprios TITULARES.",
			p5: "Os TITULARES sempre devem fornecer informações verdadeiras ao utilizar nossos produtos e serviços, sob pena das sanções legais cabíveis.",
		},
		section6: {
			title: "VI. DO CONTATO DO ENCARREGADO DE DADOS",
			p1: "Para eventuais necessidades de contato, exercer seus direitos e tirarem dúvidas com a PRIMI é possível utilizar o contato direto do Encarregado de Dados, Sr(a) Victória Colombarolli Ferreira.",
			p2: "Contato:",
			email: "dpo@primi.com.br",
		},
		section7: {
			title: "VII. DISPOSIÇÕES FINAIS",
			p1: "Por fim, a PRIMI se reserva o direito de modificar esta política e aviso de privacidade a qualquer tempo, sempre mantendo atualizado e disponível em",
			link: "https://primi.com.br/privacidade",
		},
		copyright: "© {year} Primi Tecnologia Ltda. Todos os direitos reservados.",
	},
	termsOfUsagePage: {
		title: "Termos e Condições de Uso",
		subtitle: "Plataforma Validador",
		introP1:
			"Estes Termos e Condições de Uso faz a definição das regras gerais do PORTAL S.I., disponibilizada através de portal eletrônico no domínio",
		introP1End: ", entre as partes abaixo:",
		introP2:
			"Primi Tecnologia Ltda. (PRIMI), com sede à Estrada Rosa Scarpa, nº 65, Votuparim, Santana de Parnaíba, São Paulo – SP, CEP nº 06513-010.",
		introP3:
			"E, do outro lado, pessoa física ou jurídica, identificada no cadastro do PORTAL S.I., que será chamada de USUÁRIO. A leitura e o aceite deste documento implicam na aceitação destes Termos e Condições de Uso do PORTAL S.I.",
		introP4:
			"Caso você não concorde com qualquer disposição destes Termos, por favor, não utilize nossos serviços. Esses Termos não se aplicam às páginas de Internet de terceiros e/ou a serviços e produtos fornecidos por terceiros, ainda que tenham conexão com o PORTAL S.I., sejam anunciados ou divulgados no PORTAL S.I., ou que tenham sido acessados, de qualquer forma, através do PORTAL S.I.",
		introP5:
			"A qualquer tempo o PORTAL S.I. se reserva ao direito de alterar estes Termos e Condições de Uso, para refletir adequadamente os serviços, as políticas e as práticas atualizadas.",
		section1: {
			title: "I. DOS SERVIÇOS E DISPOSIÇÕES GERAIS",
			p1: "O PORTAL S.I. é uma plataforma gratuita destinada à busca de informações e processos sobre a originalidade, procedência adequação de impressos e dispositivos de segurança, de acordo com os critérios estabelecidos nestes Termos.",
			p2: "A proposta do PORTAL S.I. é exclusivamente informar e orientar os cidadãos de forma simples, fácil e transparente sobre adequação de selos de segurança.",
			p3: "O USUÁRIO declara e reconhece que toda consulta efetuada no PORTAL S.I. será feita levando-se em consideração, exclusivamente, as bases de dados por ele mesmo produzida, não se responsabilizando o PORTAL S.I. por erros de resultado oriundos de informações incompletas, informações equivocadas, erros de procedimento ou falhas no equipamento do USUÁRIO.",
			p4: "Nesse sentido, o PORTAL S.I. não garante, em qualquer hipótese, que qualquer consulta efetuada determine que o selo consultado seja original ou falso, sendo sempre obrigação do USUÁRIO conferir as informações contidas no selo, solicitar uma análise física do selo junto ao PORTAL S.I. ou mesmo buscar orientação junto às autoridades de fiscalização.",
			p5: "A qualquer momento poderão ser incluídos novos tipos de perguntas e atividades, considerando a necessidade, relevância, pertinência e disponibilidade dessas informações.",
		},
		section2: {
			title: "II. DAS DEFINIÇÕES",
			p1: "As definições estão contidas na Política de Privacidade da PRIMI.",
		},
		section3: {
			title: "III. DA PROPRIEDADE INTELECTUAL",
			p1: "Todo o conteúdo, material e serviços encontrados no PORTAL S.I. (textos, imagens, áudio, tecnologia, logotipos, slogans, marcas, expressões de propaganda, domínios, nomes comerciais, obras intelectuais), bem como os softwares que viabilizam as atividades, são de exclusiva propriedade da PRIMI, que detém todos os direitos autorais, licenciamentos e direitos de propriedade, marca ou patente a eles relativos. Qualquer violação dos direitos de propriedade intelectual pelo USUÁRIO resultará na sua responsabilidade, direta e pessoal, pelos atos praticados, nos termos da lei e com a aplicação das sanções cabíveis cíveis e criminais.",
			p2: "O USUÁRIO se compromete a não reproduzir, duplicar, copiar ou explorar os serviços prestados, softwares utilizados e/ou materiais disponibilizados pela PRIMI, para quaisquer fins não expressamente autorizados no presente termo, sem sua autorização por escrito. É vedada, igualmente, a utilização de engenharia reversa pelo USUÁRIO.",
		},
		section4: {
			title: "IV. DO PRAZO, RESCISÃO E MODIFICAÇÃO DE CLÁUSULAS",
			p1: "Os presentes Termos vigorarão por tempo indeterminado ou durante o período em que o PORTAL S.I. estiver disponível. O PORTAL S.I., no entanto, reserva-se o direito de, a qualquer momento, sem qualquer ônus ou aviso prévio, encerrar suas atividades ou limitar o uso de seus serviços.",
			p2: "O PORTAL S.I. reserva-se o direito de bloquear o acesso do USUÁRIO e rescindir de imediato, sem aviso prévio, estes Termos, toda vez que, a seu exclusivo critério, entender que há indícios de utilização fraudulenta ou ilícita do PORTAL S.I. pelo USUÁRIO. Inclui-se na presente situação, entre outras, quaisquer indícios - a critério único e subjetivo do PORTAL S.I. – de que o USUÁRIO fraudou ou infringiu o sistema de segurança.",
		},
		section5: {
			title: "V. DA AUSÊNCIA DE RESPONSABILIDADE DO PORTAL S.I.",
			p1: "O USUÁRIO reconhece e concorda que, embora o PORTAL S.I. faça o possível para veicular a pesquisa mais acurada sobre os selos de segurança para extintores de incêndio, não é possível garantir a exatidão, a efetividade ou a adequação de quaisquer informações apontadas.",
			p2: "O USUÁRIO, deve assumir inteira responsabilidade e aceitar todos os riscos inerentes ao uso das PORTAL S.I. Qualquer informação relacionada ou disponível no PORTAL S.I., incluindo o resultado de pesquisas efetuadas, são apresentadas na confiança e condição de que o USUÁRIO prestou e cumpriu todas as etapas de forma fidedigna, sendo que não foram criadas para atender necessidades específicas, tampouco para orientar o USUÁRIO sobre o cumprimento da legislação vigente ou, ainda, para influenciar negativamente o processo de compra ou escolha de qualquer fornecedor especifico, e podem incluir imprecisões técnicas, legais, regulatórias ou erros tipográficos.",
			p3: "O PORTAL S.I. se reserva o direito de acrescentar, excluir ou modificar suas funcionalidades e escopos, no todo ou em parte, a qualquer momento, sem prévio aviso.",
			p4: "O PORTAL S.I. envidará seus melhores esforços para manter-se acessível forma constante, ininterrupta e isenta de quaisquer erros; no entanto, o PORTAL S.I. não será responsável por danos decorrentes de falha ou interrupção na prestação dos serviços disponíveis.",
			p5: "O PORTAL S.I. não oferece garantias de qualquer natureza quanto às consultas efetuadas. Neste sentido, o USUÁRIO declara estar ciente e concordar que o PORTAL S.I. se exime de qualquer responsabilidade por quaisquer declarações ou garantias implícitas ou aqui não expressamente previstas, incluindo, sem limitação, quaisquer garantias de adequação para uma finalidade específica.",
			p6: "O PORTAL S.I. não se responsabiliza e não oferece qualquer garantia da exatidão, efetividade, oportunidade e adequação de qualquer informação, conteúdo, produto ou serviço fornecido por terceiros, inclusive hyperlinks para páginas de terceiros.",
			p7: "O PORTAL S.I. não garante que as estar livre de erros e/ou que as esteja disponível 24 (vinte e quatro) horas por dia durante 7 (sete) dias da semana. O PORTAL S.I. se reserva o direito de tornar-se indisponível pelo período necessário para manutenções e/ou implementação de melhorias.",
			p8: "O PORTAL S.I. não será, em nenhuma hipótese, responsabilizado por danos indiretos, lucros cessantes ou perdas de dados relacionados à utilização.",
		},
		section6: {
			title: "VI. CONDIÇÕES GERAIS",
			p1: "O USUÁRIO, ao utilizar o PORTAL S.I., aceita expressamente todas as cláusulas do presente instrumento, bem como as atividades que existem e que venham a existir, reconhecendo-as como inocentes, saudáveis, de boa-fé e não-ofensivas, aceitando suas regras, instruções e condições constantes do próprio site, de forma absoluta e irrestrita, garantindo que não se sentirá de qualquer forma ultrajado, ofendido ou prejudicado por estas.",
			p2: "Caso o PORTAL S.I. crie atividade, que de alguma forma o USUÁRIO não considere inocente, saudável, de boa-fé ou não-ofensiva ou, ainda, que possa eventualmente ofendê-lo ou prejudicá-lo, o USUÁRIO obriga-se a cessar o uso dos serviços.",
			p3: "Qualquer reclamação judicial ou extrajudicial que venha a ser formulada em face do PORTAL S.I. em razão de descumprimento ou infringência de qualquer cláusula ou disposição constante do presente instrumento, obrigará o USUÁRIO a responder integralmente e, se for o caso, regressivamente, por todas as perdas e danos causados ao PORTAL S.I. e/ou a terceiros.",
			p4: "Os serviços e conteúdos disponíveis em sites de terceiros são de única e exclusiva responsabilidade do terceiro. Você reconhece e concorda que o PORTAL S.I. não garante, não endossa, não assume e não terá qualquer responsabilidade com relação a produtos, serviços ou sites de terceiros.",
			p5: "O PORTAL S.I. mantém a disposição do USUÁRIO um canal para esclarecimento de dúvidas, sugestões e reclamações relativas aos serviços prestados, através de canais de contato disponibilizados na Política de Privacidade da PRIMI.",
		},
		section7: {
			title: "VII. PRIVACIDADE, SEGURANÇA, COOKIES E TRATAMENTO DE DADOS",
			p1: "Todos os itens relacionados à Privacidade, Segurança, Cookies e Tratamento de Dados estão tratados na Política de Privacidade da PRIMI.",
		},
		section8: {
			title: "VIII. DA LEI APLICÁVEL E FORO",
			p1: "As presentes condições são regidas única e exclusivamente pelas leis da República Federativa do Brasil e qualquer discussão judicial que surja tendo por base sua interpretação ou aplicação deverá ser julgada por tribunais brasileiros, estando desde logo eleito o foro da Capital do Estado de São Paulo, por mais privilegiado que outro seja ou possa vir a ser.",
		},
		copyright: "© {year} Primi Tecnologia Ltda. Todos os direitos reservados.",
	},
	cookieConsentBanner: {
		description:
			"Utilizamos cookies para auxiliar a sua navegação em nosso site e melhorar nossos serviços. Ao continuar navegando, você concorda com nossos Termos de Uso e nossa",
		privacyLink: "Política de Privacidade.",
		descriptionSuffix: "",
		acceptAll: "Aceitar todos os cookies",
		rejectNonEssential: "Rejeitar cookies",
	},
};
